import { useEffect, useRef } from 'react';
import { saveSubscriptionFlagsFromUrl } from '../utils/subscriptionFlags';

/**
 * Hook that saves subscription flags from URL params to cookies on app load.
 * This mirrors Vue's App.vue trackTraffic() behavior.
 *
 * Should be called once at the app level (e.g., in MiscProvider) to ensure
 * subscription flags are persisted before the user navigates away from the
 * initial landing page (e.g., /register).
 *
 * URL params supported (matching Vue):
 * - show_promo OR promo → show_promo cookie
 * - code → discount_code cookie
 * - annual → show_annual cookie
 * - monthly → show_monthly cookie
 * - page → page cookie
 * - subscription_tier → subscription_tier cookie
 * - subscription_annual → subscription_annual cookie
 * - trialDays → trial_days cookie
 */
export function useSubscriptionFlagsTracking(): void {
    const hasTracked = useRef(false);

    useEffect(() => {
        // Only run once on initial app load
        if (hasTracked.current) return;
        hasTracked.current = true;

        saveSubscriptionFlagsFromUrl();
    }, []);
}
